const LOCALHOST_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);
const PRODUCTION_VENDOR_SOURCE_USES = new Set([
  "production",
  "production_internal",
  "production_search",
]);

export function isLocalhostViewer(hostname = typeof window !== "undefined" ? window.location.hostname : "") {
  const host = String(hostname || "").split(":")[0].toLowerCase();
  return LOCALHOST_HOSTS.has(host) || host.endsWith(".localhost");
}

export function filterVendorSearchesForViewer(sources, hostname) {
  if (isLocalhostViewer(hostname)) return sources || [];
  return (sources || []).filter((source) =>
    PRODUCTION_VENDOR_SOURCE_USES.has(source?.management?.productionUse)
  );
}
